/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BranchDto } from '../../models/branch-dto';

export interface BranchClientControllerFindByIdV1$Params {
  id: string;
}

export function branchClientControllerFindByIdV1(http: HttpClient, rootUrl: string, params: BranchClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BranchDto>> {
  const rb = new RequestBuilder(rootUrl, branchClientControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BranchDto>;
    })
  );
}

branchClientControllerFindByIdV1.PATH = '/api/v1/branches/client/{id}';
